//import "./../../studentassets/css/style.css";
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Header from "./Header/Header";
import LeftSidebar from "./LeftSidebar/LeftSidebar";
import RightSidebar from "./RightSidebar/RightSidebar";
import icon03 from "../../studentassets/images/avatar/03.png";
import icon04 from "../../studentassets/images/avatar/04.png";
import { FaRegBookmark } from "react-icons/fa6";
import { FaRegThumbsUp } from "react-icons/fa";
import { FaRegThumbsDown } from "react-icons/fa";
import { useSelector } from 'react-redux';
import { selectMode } from '../../service/slice/ThemeSlice';
import { FaPenToSquare } from "react-icons/fa6";
import { useEffect } from 'react';
import { HiArrowNarrowUp } from "react-icons/hi";
import QuestionAns from './QuestionAns';

export default function Dashboard() {
  const theme = useSelector(selectMode);
  const userDetails = useSelector((state) => state.userSlice);
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");

  const location = useLocation();

  const search = location.state?.search;
  const selectedFile = location.state?.selectedFile;


  useEffect(() => {
    if (!authToken) {
      navigate("/signin");
    }
  }, [userDetails])

  return (
    <>
      {/* Header */}
      {/* <Header /> */}
      {/* <div className="dash-board-main-wrapper"> */}

      {/* Left Sidebar */}
      {/* <LeftSidebar /> */}

      {/* Dashboard Question Details */}
      {/* <div className="main-center-content-m-left center-content search-sticky" style={{ maxHeight: "1000em", }}> */}

      <div className="question_answer__wrapper__chatbot">
        <QuestionAns />

      </div>

      {/* <div className='col-md-4'>
        <div className="search-form">
          <input type="text" placeholder="Message ..." style={{ background: theme === 'light' ? '#fff' : '#121B32', color: theme === 'light' ? '#000' : '#fff' }} />
          <button><HiArrowNarrowUp /></button>
        </div>
      </div> */}

      {/* </div> */}

      {/* Right Sidebar */}
      <RightSidebar />
      {/* </div> */}
    </>
  )
}
